<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-4 searching">
                                <span class="h_page">Laporan Perjanjian</span> <br> <br>
                            </div>
                            <div class="col-md-5">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button  @click="Printing"  type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data"><i class="material-icons">print</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Instansi</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_instansi/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="instansi"
                                    :initValue="''"
                                    :placeholder="instansi_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="form.tahun" @change="getSetupRenstra()">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Jenis Renja</span>
                                <select class="form-control" v-model="form.renja_setup_id">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_renja_setup" :key="data.renja_setup_id" :value="data.renja_setup_id">{{data.renja_jenis}}</option>
                                </select>
                            </div>

                            

                        </div>
                        <br>

                        <hr>

                        <div id="printMe">
                           <div>
                            <!-- V_FOR LEVEL I-->
                                <div >
                                    <!-- <div class="table-responsive"> -->
                                        <table style="width: 100% !important">
                                            <tr>
                                                <td style="width: 10%" class="text-right">
                                                    <img src="images/logo konsel.png" alt="" width="50">
                                                </td>
                                                <td style="width: 90% !important" class="text-center h_kop_1">
                                                    <b class="text-center">
                                                        <span>PERJANJIAN KINERJA TAHUN {{form.tahun}}</span> <br>
                                                        {{instansi_full}} <br/>
                                                        <span>KABUPATEN KONAWE SELATAN</span>
                                                    </b>
                                                </td >
                                                <td style="width: 10% !important"></td>
                                            </tr>
                                        </table>
                                        <hr>

                                        <!-- ========== ISI LAPORAN ============ -->
                                            <p>
                                                Dalam rangka mewujudkan manajemen pemerintahan yang efektif, transparan, dan akuntabel serta berorientasi pada hasil, 
                                                kami yang bertanda tangan di bawah ini :  
                                            </p>

                                            <div style="padding-left:2% !important">
                                                <table style="width: 100% !important;">
                                                    <tr>
                                                        <td style="width: 10% !important">Nama</td>
                                                        <td style="width: 5% !important"> :</td>
                                                        <td style="">{{check_gelar_depan(objJabatanLV1.biodata_gelar_depan)}} {{objJabatanLV1.biodata_nama}} {{check_gelar_belakang(objJabatanLV1.biodata_gelar_belakang)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="">Jabatan</td>
                                                        <td style=""> :</td>
                                                        <td style="">{{objJabatanLV1.jabatan}} {{objJabatanLV1.unit_kerja_nama}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"><br> Selanjutnya di sebut pihak pertama</td>
                                                    </tr>
                                                </table>

                                                <br>
                                                <table style="width: 100% !important;">
                                                    <tr>
                                                        <td style="width: 10% !important">Nama</td>
                                                        <td style="width: 5% !important"> :</td>
                                                        <td style="">H. SURUNUDDIN DANGGA, ST.,MM</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="">Jabatan</td>
                                                        <td style=""> :</td>
                                                        <td style="">Bupati Konawe Selatan</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"><br>Selaku atasan langsung pihak pertama</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <br>
                                            <p style="text-align: justify">
                                                Pihak pertama pada tahun {{form.tahun}} ini berjanji akan mewujudkan target kinerja tahunan
                                                sesuai lampiran perjanjian ini dalam rangka mencapai target kinerja jangka
                                                menengah seperti yang telah ditetapkan dalam dokumen perencanaan.
                                            </p>
                                            <p style="text-align: justify">
                                                Keberhasilan dan kegagalan pencapaian target kinerja tersebut menjadi tanggung jawab
                                                pihak pertama.
                                            </p>
                                            <p style="text-align: justify">
                                                Pihak kedua akan memberikan supervisi yang diperlukan serta akan melakukan evaluasi
                                                akuntabilitas kinerja terhadap capaian kinerja dari perjanjian ini dan mengambil tindakan
                                                yang diperlukan dalam rangka pemberian penghargaan dan sanksi.
                                            </p>

                                            <br>
                                            <table style="width: 100% !important;" class="text-center">
                                                <tr>
                                                    <td style=""></td>
                                                    <td style=""></td>
                                                    <td style="">Andoolo , Januari {{form.tahun}} <br/> <br/></td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 40% !important">Pihak Kedua,</td>
                                                    <td style="width: 20% !important"></td>
                                                    <td style="width: 40% !important">Pihak Pertama,</td>
                                                </tr>
                                                <tr>
                                                    <td style="">BUPATI KONAWE SELATAN</td>
                                                    <td style=""></td>
                                                    <td style="">{{objJabatanLV1.jabatan}} {{objJabatanLV1.unit_kerja_nama}}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"><br><br><br><br></td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;text-decoration: underline;">H. SURUNUDDIN DANGGA, ST.,MM</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;text-decoration: underline;">{{check_gelar_depan(objJabatanLV1.biodata_gelar_depan)}} {{objJabatanLV1.biodata_nama}} {{check_gelar_belakang(objJabatanLV1.biodata_gelar_belakang)}}</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;"></td>
                                                    <!-- <td style="font-weight: bold;">Pembina Utama Muda</td> -->
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">{{objJabatanLV1.biodata_nip}}</td>
                                                </tr>
                                            </table>
                                            <!-- <hr> -->

                                            <div class="pagebreak" style="page-break-after: always !important;"><hr></div>

                                            <div  class="text-center">
                                                <b>
                                                    <span>LAMPIRAN PERJANJIAN KINERJA TAHUN {{form.tahun}}</span> <br>
                                                    BIDANG TEKNOLOGI INFORMASI DAN KOMUNIKASI <br/>
                                                    <span>KABUPATEN KONAWE SELATAN</span>
                                                </b>
                                            </div>
                                            <br><br>
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="kepala_table_f tabel_center">
                                                    <th class="text-center" style="width: 5%">No</th>
                                                    <th class="text-center" style="width: 40%">Sasaran Strategis</th>
                                                    <th class="text-center" style="width: 45%">Indikator Kinerja</th>
                                                    <th class="text-center" style="width: 10%">Target</th>
                                                </tr>
                                                </thead>
                                                <tbody class="tabel_center" >
                                                    <tr class="h_isitable" v-for="(data, index1) in list_getSasaranOPDLV1" :key="data.renstra_sasaran_id">
                                                        <td class="tabel_center text-center" :rowspan="check_length(data.renstra_indikator_sasaran)">{{index1+1}}</td>
                                                        <td class="tabel_center" :rowspan="check_length(data.renstra_indikator_sasaran)">{{data.renstra_sasaran_uraian}}</td>
                                                        <template v-for="data1 in data.renstra_indikator_sasaran">
                                                            <td class="tabel_center" :key="data1.renstra_indikator_sasaran_id">{{data1.renstra_indikator_sasaran_uraian}}</td>
                                                            <td class="tabel_center" :key="data1.renstra_indikator_sasaran_id+'x1'">{{check_target_tahun(data1)}} {{data1.renstra_indikator_sasaran_satuan}}</td>
                                                        </template>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <br><br>
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="kepala_table_f tabel_center">
                                                    <th class="text-center" style="width: 5%">No</th>
                                                    <th class="text-center" style="width: 65%">Program</th>
                                                    <th class="text-center" style="width: 20%">Anggaran</th>
                                                    <th class="text-center" style="width: 10%">Keterangan</th>
                                                </tr>
                                                </thead>
                                                <tbody class="tabel_center" >
                                                    <template v-for="(data, index) in list_getProgramLV1">
                                                        <tr class="h_isitable" :key="data.renja_program_id">
                                                            <td class="tabel_center text-center">{{index+1}}</td>
                                                            <td class="tabel_center">[{{data.program_kode}}] {{data.program_nama}}</td>
                                                            <td class="tabel_center text-right">{{format_uang(data.TOTAL)}}</td>
                                                            <td class="tabel_center text-center">-</td>
                                                        </tr>
                                                    </template>

                                                </tbody>
                                            </table>
                                            <br>
                                            <table style="width: 100% !important;" class="text-center">
                                                <tr>
                                                    <td style=""></td>
                                                    <td style=""></td>
                                                    <td style="">Andoolo , Januari {{form.tahun}} <br/> <br/></td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 40% !important">Pihak Kedua,</td>
                                                    <td style="width: 20% !important"></td>
                                                    <td style="width: 40% !important">Pihak Pertama,</td>
                                                </tr>
                                                <tr>
                                                    <td style="">Bupati Konawe Selatan</td>
                                                    <td style=""></td>
                                                    <td style="">Kepala DinasPeternakan dan Kesehatan Hewan</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"><br><br><br><br></td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;text-decoration: underline;">H. SURUNUDDIN DANGGA, ST.,MM</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;text-decoration: underline;">{{check_gelar_depan(objJabatanLV1.biodata_gelar_depan)}} {{objJabatanLV1.biodata_nama}} {{check_gelar_belakang(objJabatanLV1.biodata_gelar_belakang)}}</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">Pembina Utama Muda</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">{{objJabatanLV1.biodata_nip}}</td>
                                                </tr>
                                            </table>
                                            <div class="pagebreak" style="page-break-after: always !important;"><hr></div>
                                        <!-- ========== ISI LAPORAN ============ -->
                                    </div>
                            <!-- V_FOR LEVEL I-->

                            <!-- V_FOR LEVEL II-->
                                <div >
                                    <!-- <div class="table-responsive"> -->
                                        <table style="width: 100% !important">
                                            <tr>
                                                <td style="width: 10%" class="text-right">
                                                    <img src="images/logo konsel.png" alt="" width="50">
                                                </td>
                                                <td style="width: 90% !important" class="text-center h_kop_1">
                                                    <b class="text-center">
                                                        <span>PERJANJIAN KINERJA TAHUN {{form.tahun}}</span> <br>
                                                        {{instansi_full}} <br/>
                                                        <span>KABUPATEN KONAWE SELATAN</span>
                                                    </b>
                                                </td >
                                                <td style="width: 10% !important"></td>
                                            </tr>
                                        </table>
                                        <hr>

                                        <!-- ========== ISI LAPORAN ============ -->
                                            <p>
                                                Dalam rangka mewujudkan manajemen pemerintahan yang efektif, transparan, dan akuntabel serta berorientasi pada hasil, 
                                                kami yang bertanda tangan di bawah ini :  
                                            </p>

                                            <div style="padding-left:2% !important">
                                                <table style="width: 100% !important;">
                                                    <tr>
                                                        <td style="width: 10% !important">Nama</td>
                                                        <td style="width: 5% !important"> :</td>
                                                        <td style="">Ir. SAHRAD</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="">Jabatan</td>
                                                        <td style=""> :</td>
                                                        <td style="">Sekretaris DinasPeternakan dan Kesehatan Hewan</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"><br> Selanjutnya di sebut pihak pertama</td>
                                                    </tr>
                                                </table>

                                                <br>
                                                <table style="width: 100% !important;">
                                                    <tr>
                                                        <td style="width: 10% !important">Nama</td>
                                                        <td style="width: 5% !important"> :</td>
                                                        <td style="">Ir.RAFIUDDIN SILONDAE</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="">Jabatan</td>
                                                        <td style=""> :</td>
                                                        <td style="">Kepala Dinas Peternakan dan Kesehatan Hewan</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"><br>Selaku atasan langsung pihak pertama</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <br>
                                            <p style="text-align: justify">
                                                Pihak pertama pada tahun {{form.tahun}} ini berjanji akan mewujudkan target kinerja tahunan
                                                sesuai lampiran perjanjian ini dalam rangka mencapai target kinerja jangka
                                                menengah seperti yang telah ditetapkan dalam dokumen perencanaan.
                                            </p>
                                            <p style="text-align: justify">
                                                Keberhasilan dan kegagalan pencapaian target kinerja tersebut menjadi tanggung jawab
                                                pihak pertama.
                                            </p>
                                            <p style="text-align: justify">
                                                Pihak kedua akan memberikan supervisi yang diperlukan serta akan melakukan evaluasi
                                                akuntabilitas kinerja terhadap capaian kinerja dari perjanjian ini dan mengambil tindakan
                                                yang diperlukan dalam rangka pemberian penghargaan dan sanksi.
                                            </p>

                                            <br>
                                            <table style="width: 100% !important;" class="text-center">
                                                <tr>
                                                    <td style=""></td>
                                                    <td style=""></td>
                                                    <td style="">Andoolo , Januari {{form.tahun}} <br/> <br/></td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 40% !important">Pihak Kedua,</td>
                                                    <td style="width: 20% !important"></td>
                                                    <td style="width: 40% !important">Pihak Pertama,</td>
                                                </tr>
                                                <tr>
                                                    <td style="">Kepala Dinas Peternakan dan Kesehatan Hewan</td>
                                                    <td style=""></td>
                                                    <td style="">Sekretaris DinasPeternakan dan Kesehatan Hewan</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"><br><br><br><br></td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;text-decoration: underline;">Ir.RAFIUDDIN SILONDAE</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;text-decoration: underline;">Ir. SAHRAD</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;">Pembina Utama Muda</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">Pembina Tingkat 1</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;">198511202014061001</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">196502222000031002</td>
                                                </tr>
                                            </table>
                                            <!-- <hr> -->

                                            <div class="pagebreak" style="page-break-after: always !important;"><hr></div>

                                            <div  class="text-center">
                                                <b>
                                                    <span>LAMPIRAN PERJANJIAN KINERJA TAHUN {{form.tahun}}</span> <br>
                                                    SEKRETARIS DINAS PETERNAKAN DAN KESEHATAN HEWAN <br/>
                                                    <span>KABUPATEN KONAWE SELATAN</span>
                                                </b>
                                            </div>
                                            <br><br>
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="kepala_table_f tabel_center">
                                                    <th class="text-center" style="width: 5%">No</th>
                                                    <th class="text-center" style="width: 40%">Sasaran Program</th>
                                                    <th class="text-center" style="width: 50%">Indikator Kinerja</th>
                                                    <th class="text-center" style="width: 5%">Target</th>
                                                </tr>
                                                </thead>
                                                <tbody class="tabel_center" >
                                                    <tr class="h_isitable">
                                                        <td class="tabel_center">1</td>
                                                        <td class="tabel_center">xxxxx</td>
                                                        <td class="tabel_center">xxxxx</td>
                                                        <td class="tabel_center">xxxxx</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <br><br>
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="kepala_table_f tabel_center">
                                                    <th class="text-center" style="width: 5%">No</th>
                                                    <th class="text-center" style="width: 65%">Program</th>
                                                    <th class="text-center" style="width: 20%">Anggaran</th>
                                                    <th class="text-center" style="width: 10%">Keterangan</th>
                                                </tr>
                                                </thead>
                                                <tbody class="tabel_center" >
                                                    <template >
                                                        <tr class="h_isitable">
                                                            <td class="tabel_center">1</td>
                                                            <td class="tabel_center">xxxxx</td>
                                                            <td class="tabel_center">xxxxx</td>
                                                            <td class="tabel_center">xxxxx</td>
                                                        </tr>
                                                    </template>

                                                </tbody>
                                            </table>
                                            <br>
                                            <table style="width: 100% !important;" class="text-center">
                                                <tr>
                                                    <td style=""></td>
                                                    <td style=""></td>
                                                    <td style="">Andoolo , Januari {{form.tahun}} <br/> <br/></td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 40% !important">Pihak Kedua,</td>
                                                    <td style="width: 20% !important"></td>
                                                    <td style="width: 40% !important">Pihak Pertama,</td>
                                                </tr>
                                                <tr>
                                                    <td style="">Kepala Dinas Peternakan dan Kesehatan Hewan</td>
                                                    <td style=""></td>
                                                    <td style="">Sekretaris DinasPeternakan dan Kesehatan Hewan</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"><br><br><br><br></td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;text-decoration: underline;">Ir.RAFIUDDIN SILONDAE</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;text-decoration: underline;">Ir. SAHRAD</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;">Pembina Utama Muda</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">Pembina Tingkat 1</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;">198511202014061001</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">196502222000031002</td>
                                                </tr>
                                            </table>
                                            <div class="pagebreak" style="page-break-after: always !important;"><hr></div>
                                        <!-- ========== ISI LAPORAN ============ -->
                                    </div>
                            <!-- V_FOR LEVEL II-->

                            <!-- V_FOR LEVEL III-->
                                <div>
                                    <!-- <div class="table-responsive"> -->
                                        <table style="width: 100% !important">
                                            <tr>
                                                <td style="width: 10%" class="text-right">
                                                    <img src="images/logo konsel.png" alt="" width="50">
                                                </td>
                                                <td style="width: 90% !important" class="text-center h_kop_1">
                                                    <b class="text-center">
                                                        <span>PERJANJIAN KINERJA TAHUN {{form.tahun}}</span> <br>
                                                        {{instansi_full}} <br/>
                                                        <span>KABUPATEN KONAWE SELATAN</span>
                                                    </b>
                                                </td >
                                                <td style="width: 10% !important"></td>
                                            </tr>
                                        </table>
                                        <hr>

                                        <!-- ========== ISI LAPORAN ============ -->
                                            <p>
                                                Dalam rangka mewujudkan manajemen pemerintahan yang efektif, transparan, dan akuntabel serta berorientasi pada hasil, 
                                                kami yang bertanda tangan di bawah ini :  
                                            </p>

                                            <div style="padding-left:2% !important">
                                                <table style="width: 100% !important;">
                                                    <tr>
                                                        <td style="width: 10% !important">Nama</td>
                                                        <td style="width: 5% !important"> :</td>
                                                        <td style="">
                                                            Nama Pejabat
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="">Jabatan</td>
                                                        <td style=""> :</td>
                                                        <td style="">Jabatan Pejabat</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"><br> Selanjutnya di sebut pihak pertama</td>
                                                    </tr>
                                                </table>

                                                <br>
                                                <table style="width: 100% !important;">
                                                    <tr>
                                                        <td style="width: 10% !important">Nama</td>
                                                        <td style="width: 5% !important"> :</td>
                                                        <td style="">
                                                            Nama Atasan Pejabat
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="">Jabatan</td>
                                                        <td style=""> :</td>
                                                        <td style="">Jabatan Atasan Pejabat</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"><br>Selaku atasan langsung pihak pertama</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <br>
                                            <p style="text-align: justify">
                                                Pihak pertama pada tahun {{form.tahun}} ini berjanji akan mewujudkan target kinerja tahunan
                                                sesuai lampiran perjanjian ini dalam rangka mencapai target kinerja jangka
                                                menengah seperti yang telah ditetapkan dalam dokumen perencanaan.
                                            </p>
                                            <p style="text-align: justify">
                                                Keberhasilan dan kegagalan pencapaian target kinerja tersebut menjadi tanggung jawab
                                                pihak pertama.
                                            </p>
                                            <p style="text-align: justify">
                                                Pihak kedua akan memberikan supervisi yang diperlukan serta akan melakukan evaluasi
                                                akuntabilitas kinerja terhadap capaian kinerja dari perjanjian ini dan mengambil tindakan
                                                yang diperlukan dalam rangka pemberian penghargaan dan sanksi.
                                            </p>

                                            <br>
                                            <table style="width: 100% !important;" class="text-center">
                                                <tr>
                                                    <td style=""></td>
                                                    <td style=""></td>
                                                    <td style="">Andoolo , Januari {{form.tahun}} <br/> <br/></td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 40% !important">Pihak Kedua,</td>
                                                    <td style="width: 20% !important"></td>
                                                    <td style="width: 40% !important">Pihak Pertama,</td>
                                                </tr>
                                                <tr>
                                                    <td style="">Jabatan Atasan Pejabat</td>
                                                    <td style=""></td>
                                                    <td style="">Jabatan Pejabat</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"><br><br><br><br></td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;text-decoration: underline;">
                                                        Nama atasan Pejabat
                                                    </td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;text-decoration: underline;">
                                                        Nama Pejabat
                                                    </td>
                                                </tr>
                                                <!-- <tr>
                                                    <td style="font-weight: bold;">
                                                        Pembina Tingkat 1
                                                        </td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">Penata</td>
                                                </tr> -->
                                                <tr>
                                                    <td style="font-weight: bold;">Nip Atatasan Pejabat</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">Nip Pejabat</td>
                                                </tr>
                                            </table>
                                            <!-- <hr> -->

                                            <div class="pagebreak" style="page-break-after: always !important;"><hr></div>

                                            <div  class="text-center">
                                                <b>
                                                    <span>LAMPIRAN PERJANJIAN KINERJA TAHUN {{form.tahun}}</span> <br>
                                                    <span>Jabatan Pejabat</span> <br/>
                                                    <span>KABUPATEN KONAWE SELATAN</span>
                                                </b>
                                            </div>
                                            <br><br>
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="kepala_table_f tabel_center">
                                                    <th class="text-center" style="width: 5%">No</th>
                                                    <th class="text-center" style="width: 40%">Sasaran Kegiatan</th>
                                                    <th class="text-center" style="width: 50%">Indikator Kegiatan</th>
                                                    <th class="text-center" style="width: 5%">Target</th>
                                                </tr>
                                                </thead>
                                                <tbody class="tabel_center" >
                                                    <template >
                                                        <tr class="h_isitable" >
                                                            <td class="tabel_center">1</td>
                                                            <td class="tabel_center">{{'-'}}</td>
                                                            <td class="tabel_center">uraian indikator</td>
                                                            <td class="tabel_center">targetnya</td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>

                                            <br><br>
                                            <table class="table table-bordered" style="width: 100%">
                                                <thead>
                                                <tr class="kepala_table_f tabel_center">
                                                    <th class="text-center" style="width: 5%">No</th>
                                                    <th class="text-center" style="width: 65%">Kegiatan</th>
                                                    <th class="text-center" style="width: 20%">Anggaran</th>
                                                    <th class="text-center" style="width: 10%">Keterangan</th>
                                                </tr>
                                                </thead>
                                                <tbody class="tabel_center" >
                                                    <template>
                                                        <tr class="h_isitable">
                                                            <td class="tabel_center">1</td>
                                                            <td class="tabel_center">Nama Kegiatan</td>
                                                            <td class="tabel_center text-right">Jumlah</td>
                                                            <td class="tabel_center">{{'-'}}</td>
                                                        </tr>
                                                    </template>

                                                </tbody>
                                            </table>
                                            <br>
                                            <table style="width: 100% !important;" class="text-center">
                                                <tr>
                                                    <td style=""></td>
                                                    <td style=""></td>
                                                    <td style="">Andoolo , Januari {{form.tahun}} <br/> <br/></td>
                                                </tr>
                                                <tr>
                                                    <td style="width: 40% !important">Pihak Kedua,</td>
                                                    <td style="width: 20% !important"></td>
                                                    <td style="width: 40% !important">Pihak Pertama,</td>
                                                </tr>
                                                <tr>
                                                    <td style="">Sekretaris DinasPeternakan dan Kesehatan Hewan Kabupaten Konawe Selatan</td>
                                                    <td style=""></td>
                                                    <td style="">Kasubag. Keuangan dan Aset. Dinas Peternakan dan Kesehatan Hewan Kabupaten</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="3"><br><br><br><br></td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;text-decoration: underline;">Ir. SAHRAD</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;text-decoration: underline;">FARIQAH ROHMAH, SP</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;">Pembina Tingkat 1</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">Penata</td>
                                                </tr>
                                                <tr>
                                                    <td style="font-weight: bold;">196502222000031002</td>
                                                    <td style="font-weight: bold;"></td>
                                                    <td style="font-weight: bold;">197708082008012021</td>
                                                </tr>
                                            </table>
                                            <div class="pagebreak" style="page-break-after: always !important;"><hr></div>
                                        <!-- ========== ISI LAPORAN ============ -->
                                    </div>
                            <!-- V_FOR LEVEL III-->
                           </div>

                        </div>
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->



                        
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>



<script>

    const ADD_URL = URL_APP+'api/v1/sakip_delegasi_lv2/';
    const ADD_URL_RA = URL_APP+'api/v1/sakip_realisasi_kinerja_keuangan/';

    const ADD_URL_LAP_PK = URL_APP+'api/v1/sakip_lap_perjanjian_kinerja/';

    const ADD_URL_SETUP_RENSTRA = URL_APP+'api/v1/planning_renja_setup/';
    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';

    const URL_JABATAN = URL_APP+'api/v1/simpeg_jabatan/';



    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    jabatan_id : '',
                    target : 0,
                    keterangan : '',

                    renja_kegiatan_id : '',

                    renja_setup_id : '',
                    tahun : '',
                    instansi_id : '',
                    unit_kerja : '',
                },
                objJabatanLV1 : {},
                list_getSasaranOPDLV1 : [],
                list_getProgramLV1 : [],
               



                unit_kerja : '',
                unit_kerja_full : '',
                instansi_id : '',
                instansi_full : '',


                list_renja_setup :[],

                list_data : [],


               check_data_add : false,
                page_first : 1,
                page_last : 0,
                cari_value : '',

                list_tahun : [],
                list_jabatan : [],

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.form.unit_kerja = get_profile.profile.unit_kerja;

            this.form.instansi_id = get_profile.profile.instansi_id;
            this.instansi_id = get_profile.profile.instansi_id;
            this.instansi_full = get_profile.profile.ref_instansi;


            localStorage.sidemenu = 'sakip';
            this.loadFirst()
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            loadFirst : function(){
                
                this.getDataLv1Tahun();
                this.getJabatanLV1();
                this.getSasaranOPDLV1();
            },

            loadByRenja : function(){
                this.getProgramLV1();
            },

            selectData : function(data){
                // console.log(data);

                this.form.renja_kegiatan_id = data.renja_kegiatan_id;
                this.form.renja_setup_id = data.renja_setup_id;
                this.form.tahun = data.tahun;
                this.form.instansi_id = data.instansi_id;
                this.form.unit_kerja = data.unit_kerja;

                this.rencana.renja_kegiatan_id = data.renja_kegiatan_id;
                this.jadual.renja_kegiatan_id = data.renja_kegiatan_id;
                this.serapan.renja_kegiatan_id = data.renja_kegiatan_id;
                this.kegiatan.renja_kegiatan_id = data.renja_kegiatan_id;


                this.getDataLv3Tahun();

            },



            emptyData : function(){

            },



        //TAMBAHAN
            getSetupRenstra : function(){
                fetch(ADD_URL_SETUP_RENSTRA, {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        tahun : this.form.tahun,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_renja_setup = res_data;

                    this.list_getProgramLV1 = [];


                    if (res_data.length <= 0) {
                        this.form.renja_setup_id = '';
                        this.check_data_add = false;
                    }else{
                        this.form.renja_setup_id = res_data[0].renja_setup_id
                        this.loadByRenja();

                    }
                    
                    this.check_target_tahun();
                    // console.log(res_data[0]);
                })
            },

            getJabatanLV1 : function(){
                fetch(ADD_URL_LAP_PK+'getPejabatLV1', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        instansi_id : this.instansi_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data[0]);
                    this.objJabatanLV1 = res_data[0];
                })

            },
            getSasaranOPDLV1 : function(){
                fetch(ADD_URL_LAP_PK+'getSasaranOPDLV1', {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        instansi_id : this.instansi_id,
                        tahun : this.form.tahun
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_getSasaranOPDLV1 = res_data;

                })

            },

            getProgramLV1: function(){
                // console.log(this.unit_kerja);
                this.list_data = [];
                fetch(ADD_URL_LAP_PK+'getProgramLV1', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      instansi_id : this.instansi_id,
                      renja_setup_id : this.form.renja_setup_id,
                      tahun : this.form.tahun
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_getProgramLV1 = res_data;
                  console.log(res_data);
                })
            },
            
            check_kegiatan : function(data){
                if (data == null || data == undefined || data == ''|| data == false|| data == 0) {
                    return true
                }else{
                    return false
                }
            },

            check_length : function(data){
                return data.length
            },
            check_target_tahun: function(data){
                var thn_length = (parseInt(data.tahun_akhir) - parseInt(data.tahun_awal));
                var thn_awal = parseInt(data.tahun_awal);
                var list_tahun = [thn_awal];
                var thn_saat_ini = this.form.tahun
                for (let i = 0; i < thn_length; i++) {
                    thn_awal = thn_awal+1
                    list_tahun.push(thn_awal)
                }

                    if (thn_saat_ini == list_tahun[0]) {
                        return this.format_uang(data.renstra_indikator_sasaran_thn_1);
                    } 
                    else if (thn_saat_ini == list_tahun[1]) {
                        return this.format_uang(data.renstra_indikator_sasaran_thn_2);
                    }
                    else if (thn_saat_ini == list_tahun[2]) {
                        return this.format_uang(data.renstra_indikator_sasaran_thn_3);
                    }
                    else if (thn_saat_ini == list_tahun[3]) {
                        return this.format_uang(data.renstra_indikator_sasaran_thn_4);
                    }
                    else if (thn_saat_ini == list_tahun[4]) {
                        return this.format_uang(data.renstra_indikator_sasaran_thn_5);
                    }
                    else if (thn_saat_ini == list_tahun[5]) {
                        return this.format_uang(data.renstra_indikator_sasaran_thn_6);
                    }

            },




        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.instansi}</b></span>
                <span style='font-size:80%'>${data.alamat}</span>
                `
            },
            getAuto : function(obj){
                this.list_data = [];
                this.form.instansi_id = obj.id;
                this.instansi_id = obj.id
                this.instansi_full = obj.instansi
                
                this.loadFirst();
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }

            },

            cari_data : function(){
                this.page_first = 1;
            },
            btn_check_data_add : function(){
                
                if (this.form.renja_setup_id != '') {
                    this.check_data_add = true;
                }
            },
            getDataLv1Tahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    this.form.tahun = this.getTgl().tahun;
                    // console.log(res_data);

                    this.getSetupRenstra();
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear(),
                }
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (nilai == null || nilai == '' || nilai == undefined || nilai == 0 || nilai == 'NaN') {
                    if (angka == Number.isNaN(NaN)) {
                        return '0';
                    } else {
                        return 0;
                    }
                } else {
                    return (angka).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                }
            },
            Printing : function(){
                this.$htmlToPaper('printMe');
            },
            pembulatan_keatas : function(data){
                return Math.ceil(data)
            },
            check_gelar_depan : function(data){
                if (data == null || data == '' || data == undefined) {
                    return ''
                } else {
                    return data+'. '
                }
            },
            check_gelar_belakang : function(data){
                if (data == null || data == '' || data == undefined) {
                    return ''
                } else {
                    return ', '+data
                }
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
